import { get } from 'lodash-es';
import { emptyObject } from 'ui-components/default-props/empty';
import { namespace as bulkCostReview } from './cost-review/bulk.cost-review.reducer.metadata';

const selectLabelProcessing = (state) => get(state, 'labelPurchasing');
const selectLabelProcessingBatches = (state) => get(selectLabelProcessing(state), 'batches');
const selectLabelProcessingBatchGroups = (state) => get(selectLabelProcessing(state), 'batchGroups');

export const selectJobByJobGuid = (state, props) => get(state, props.jobGuid);
export const selectFlowStarted = (state) => get(state, 'bulkFlowStarted');
export const selectLbsModalId = (state) => get(state, 'lbsModalId', '');
export const selectBatchGroupByKey = (state, props) => get(selectLabelProcessingBatchGroups(state), props.batchGroupKey);
export const selectBatchGroupIdFromBatchId = (state, props) => get(selectLabelProcessingBatches(state), props.batchId);
export const selectPurchasePostageIsLoading = (state) => get(state, 'purchasePostageLoading');
export const selectInsurancePurchaseErrorMessage = (state) => get(state, 'InsurancePurchaseErrorMessage');
export const selectShipDate = (state) => get(state, 'shipDate');
export const selectActiveModalStep = (state) => get(state, 'activeModalStep', emptyObject);
export const selectLabelProcessingError = (state) => get(state, 'error');
export const selectCostReview = (state) => state?.[bulkCostReview];
